import React, { Fragment } from "react";

import { NumericFormat } from "react-number-format";

import { CurrencySymbol } from "@/lib/currencySymbol";
import tickerNameFormat from "@/lib/tickerNameFormat";

import ImageWithErrorHandling from "../ImageWithErrorHandling/index";

const StockHeader = ({ stockDetail, title }) => {
  console.log("stockDetail", stockDetail);

  return (
    <Fragment>
      <div className="search-content">
        <h1 className="search-title p-0 pb-18 text-align-start fs-24">{`Is ${stockDetail?.companyName || ""} (${tickerNameFormat(stockDetail?.ticker) || ""}) ${title} a good buy?`}</h1>
        <div className="sub-title text-align-start">{`This is a step-by-step stock review to answer the question is ${stockDetail?.companyName || ""} (${tickerNameFormat(stockDetail?.ticker) || ""}) stock a good buy.`}</div>
      </div>
      <div className="desktop-search align-items-center stock-container mt-30">
        <div className="d-flex m-0 gap-15 align-items-center">
          <ImageWithErrorHandling
            src={stockDetail?.image}
            alt={`Is ${stockDetail?.companyName} (${stockDetail?.ticker}) ${stockDetail?.isEtf ? "fund" : "stock"} a good buy?`}
            className="stock-image"
          />
          <div className="stock-title d-flex gap-2">
            <span className="stock-company-name">
              {stockDetail?.companyName}
            </span>{" "}
            <span className="stock-ticker">
              {tickerNameFormat(stockDetail?.ticker)}
            </span>
          </div>
        </div>
        <div className="stock-price ml-16 d-flex justify-content-between gap-1 align-items-center">
          <div>
            {CurrencySymbol(stockDetail?.currency)}
            <NumericFormat
              value={stockDetail?.share_price}
              displayType={"text"}
              thousandSeparator={true}
            />
            {" - "}
          </div>
          <div className="stock-exchange-name">
            <span>{stockDetail?.exchange}</span>
          </div>
        </div>
      </div>
      <div className="mobile-search align-items-center stock-container mt-30">
        <div className="d-flex justify-content-between">
          <div className="stock-title d-flex gap-4">
            <ImageWithErrorHandling
              src={stockDetail?.image}
              alt={`Is ${stockDetail?.companyName} (${stockDetail?.ticker}) ${stockDetail?.isEtf ? "fund" : "stock"} a good buy?`}
              className="stock-image"
            />
            <span className="stock-company-name company-name">
              {stockDetail?.companyName}
            </span>
          </div>
          <div className="stock-price ml-16 d-flex justify-content-between gap-4">
            <div className="mt-4">
              {CurrencySymbol(stockDetail?.currency)}
              <NumericFormat
                value={stockDetail?.share_price}
                displayType={"text"}
                thousandSeparator={true}
              />
            </div>
          </div>
        </div>
        <div className="stock-price d-flex gap-4 mt-8">
          <span className="stock-ticker">
            {tickerNameFormat(stockDetail?.ticker)}
          </span>
          <div className="stock-exchange-name responsive-exchange-name">
            <span>{stockDetail?.exchange}</span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StockHeader;
